import React, { useContext } from 'react'
import { StockReportData } from 'src/shared/security.dto'

interface StockReportContext {
  report: StockReportData
}

const StockReportContext = React.createContext<StockReportContext>({} as any)

interface Props {
  data: StockReportContext
}

export const StockReportProvider: React.FC<Props> = ({ children, data }) => {
  return (
    <StockReportContext.Provider value={data}>
      {children}
    </StockReportContext.Provider>
  )
}

export const useStockReportContext = () => useContext(StockReportContext)
